import React from 'react'

function CommissionNextGenIcon(props: React.ComponentPropsWithoutRef<'svg'>) {
  return (
    <svg
      id="Composant_127_2"
      data-name="Composant 127 – 2"
      xmlns="http://www.w3.org/2000/svg"
      width="35"
      height="35"
      viewBox="0 0 35 35"
      {...props}
    >
      <g id="Groupe_3402" data-name="Groupe 3402" transform="translate(-863 -1502)">
        <circle
          id="Ellipse_2975"
          data-name="Ellipse 2975"
          cx="17.5"
          cy="17.5"
          r="17.5"
          transform="translate(863 1502)"
          fill="#f1f4f8"
        />
        <g id="Groupe_2819" data-name="Groupe 2819" transform="translate(493.176 1350.037)">
          <path
            id="Tracé_22384"
            data-name="Tracé 22384"
            d="M383.587,163.963h-3.763l5.387,5.387-5.387,5.387h3.763l5.387-5.387Z"
            fill="rgba(96,96,96,0.51)"
          />
          <path
            id="Tracé_22385"
            data-name="Tracé 22385"
            d="M407.84,163.963h-3.763l5.387,5.387-5.387,5.387h3.763l5.387-5.387Z"
            transform="translate(-17.928)"
            fill="rgba(96,96,96,0.51)"
          />
        </g>
      </g>
    </svg>
  )
}

export default CommissionNextGenIcon
